export default "__VITE_ASSET__AN$kVv46__"